import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToPricing = () => {
    window.location.href = '/pricing';
  };
  return <section className="relative bg-white dark:bg-[#0C1B26] overflow-hidden" data-id="element-263">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[700px]" data-id="element-264">
        {/* Left Column - Hero Image (Desktop) / Second on Mobile */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative order-2 lg:order-1 min-h-[400px] lg:min-h-full" data-id="element-265">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5nAynpZr92nWzvxTTnn6Kd/image.png" alt="Web designer sketching website wireframes and planning homepage layout - Bright Pixxel Studio professional web design process" className="absolute inset-0 w-full h-full object-cover" loading="eager" fetchPriority="high" data-id="element-266" />
        </motion.div>

        {/* Right Column - Text Content (Desktop) / First on Mobile */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-[#212C34] px-6 sm:px-8 lg:px-12 xl:px-16 py-12 lg:py-16 flex flex-col justify-center order-1 lg:order-2" data-id="element-267">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 bg-[#0DC3DC]/20 px-4 py-2 rounded-full mb-6 w-fit" data-id="element-268">
            <span className="w-2 h-2 bg-[#0DC3DC] rounded-full animate-pulse" data-id="element-269"></span>
            <span className="text-sm font-medium text-[#0DC3DC]" data-id="element-270">
              Professional Web Design Studio
            </span>
          </div>

          <h1 className="font-bold mb-6 leading-tight text-white text-[clamp(2rem,5vw,3.5rem)]" data-id="element-271">
            Web Design That Turns Visitors Into Customers
          </h1>

          <p className="text-white/90 mb-8 leading-relaxed text-[clamp(1rem,1.5vw,1.25rem)]" data-id="element-272">
            UK-based web design, e-commerce and SEO built for performance and
            results.
          </p>

          {/* Key Benefits */}
          <div className="space-y-3 mb-8" data-id="element-273">
            <div className="flex items-center gap-3" data-id="element-274">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-275">
                <svg className="w-3 h-3 text-[#0DC3DC]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-276">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-277" />
                </svg>
              </div>
              <span className="text-white/80 text-base" data-id="element-278">
                Fast turnaround: 7-14 days
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-279">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-280">
                <svg className="w-3 h-3 text-[#0DC3DC]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-281">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-282" />
                </svg>
              </div>
              <span className="text-white/80 text-base" data-id="element-283">
                100% ownership - no lock-ins
              </span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-284">
            <button onClick={scrollToContact} className="w-full sm:w-auto px-8 py-4 bg-[#0DC3DC] text-[#0C1B26] font-bold rounded-full shadow-lg hover:bg-[#0DC3DC]/90 transition-all duration-300 hover:scale-105 min-h-[44px] text-base md:text-lg" aria-label="Get your free homepage design" data-id="element-285">
              Get your free homepage design
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="pt-6 border-t border-white/10" data-id="element-286">
            <p className="text-white/60 text-xs mb-3" data-id="element-287">
              Trusted by UK businesses
            </p>
            <div className="flex items-center gap-6 text-white/70 text-sm" data-id="element-288">
              <div className="flex items-center gap-2" data-id="element-289">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-290">50+</span>
                <span className="text-xs" data-id="element-291">
                  Projects
                  <br data-id="element-292" />
                  Delivered
                </span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-293"></div>
              <div className="flex items-center gap-2" data-id="element-294">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-295">5★</span>
                <span className="text-xs" data-id="element-296">
                  Client
                  <br data-id="element-297" />
                  Rating
                </span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-298"></div>
              <div className="flex items-center gap-2" data-id="element-299">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-300">24h</span>
                <span className="text-xs" data-id="element-301">
                  Response
                  <br data-id="element-302" />
                  Time
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Risk-Reversal Bar */}
      <div className="w-full bg-[#1A242B] border-t border-b border-white/5 py-4 relative z-10 shadow-md" data-id="element-303">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-center sm:text-left" data-id="element-305">
            <span className="text-white/90 font-medium text-[15px] md:text-base" data-id="element-306">
              We design your new homepage first — free. Only pay if you love it.
            </span>
            <a href="/contact" className="inline-flex items-center text-[#0DC3DC] hover:text-white font-bold text-[15px] md:text-base transition-colors" data-id="element-307">
              Get started{' '}
              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-308">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-309" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>;
}